/**
 * MetaBadges — сквозной компонент меток SEO (§9.1 ТЗ): уверенность · impact×effort ·
 * поисковик. Переиспользуется во всех блоках раздела (находки, задачи, кластеры).
 */

import { Badge } from '@/shared/ui';
import type { Confidence, Impact, Effort, Engine } from '@/hooks/api/useSeo';

const CONF_TONE: Record<Confidence, string> = {
  Confirmed: 'b-success',
  Likely: 'b-info',
  Hypothesis: 'b-warning',
};
const IMPACT_TONE: Record<Impact, string> = { high: 'b-pink', med: 'b-violet', low: 'b-neutral' };
const ENGINE_LABEL: Record<Engine, string> = { yandex: 'Яндекс', google: 'Google', both: 'Я+G' };
const ENGINE_TONE: Record<Engine, string> = { yandex: 'b-warning', google: 'b-info', both: 'b-neutral' };

export function MetaBadges({
  confidence,
  impact,
  effort,
  engine,
}: {
  confidence?: Confidence;
  impact?: Impact;
  effort?: Effort;
  engine?: Engine;
}) {
  return (
    <span className="row" style={{ gap: 6, flexWrap: 'wrap' }}>
      {confidence && <Badge tone={CONF_TONE[confidence]}>{confidence}</Badge>}
      {(impact || effort) && (
        <Badge tone={impact ? IMPACT_TONE[impact] : 'b-neutral'}>
          {impact ?? '—'}×{effort ?? '—'}
        </Badge>
      )}
      {engine && <Badge tone={ENGINE_TONE[engine]}>{ENGINE_LABEL[engine]}</Badge>}
    </span>
  );
}
